import apiClient from 'core/services/apiClient/apiClient';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';

interface UseGetQueryOptions<TData, TError>
  extends Omit<UseQueryOptions<TData, TError, TData>, 'queryFn'> {
  params?: Record<string, any>;
}

export const useGetQuery = <TData, TError = Error>(
  pathURL: string,
  options: UseGetQueryOptions<TData, TError>
) => {
  return useQuery<TData, TError>({
    queryFn: async () => {
      const { data } = await apiClient.get<TData>(pathURL, {
        params: options?.params
      });
      return data;
    },
    retry: 1,
    // disable cache
    staleTime: 0,
    gcTime: 0,
    ...options
  });
};

export const useGetRest = <TGetResult, TParams>(pathURL: string) => {
  return useMutation<TGetResult, Error, TParams>({
    mutationFn: async (params) => {
      const { data } = await apiClient.get<TGetResult>(pathURL, {
        params
      });
      return data;
    }
  });
};
